export default "__VITE_ASSET__C2OkRiTe__"